/**
 * @typedef MockAssert
 */
function MockAssert(calls) {
  this.calls = () => calls
  this.callsCount = () => calls.length
  this.mostRecentCall = () => calls[calls.length - 1] || null
}

export default MockAssert
